import React from "react";
import { Link } from "react-router-dom";
import {string} from 'prop-types';


const BannerWithButton = ({link, title}) => {
  return (
    <section className="dark-cta">
        <Link to={link}
        className="btn btn-white-border btn-block center-block text-uppercase btn-all-product">
        {title} </Link>
      </section>
  );
};
BannerWithButton.defaultProps = {
  link: '/consultation',
  title:'Book a consultation'
};

BannerWithButton.prototypes = {
  link: string,
  title: string
};

export default BannerWithButton;
